import type { ReactNode } from 'react';
import type { TFunction } from 'i18next';
import getLoginErrorMessage from './getLoginErrorMessage';
import {
  AuthenticateStatus,
  type AuthenticateApiError,
} from '@/services/login.types';

export const SERVICE_PROVIDER_ERROR_CODE =
  'SERVICE_PROVIDER_SHOULD_ONLY_USE_MOBILE_APP';

interface GetLoginErrorArgs {
  data: AuthenticateApiError | undefined;
  t: TFunction;
}

export type LoginErrorResult =
  | { kind: 'field'; message: string }
  | { kind: 'notice'; message: ReactNode }
  | { kind: 'service-provider' };

const errorCodesToMessages: Partial<Record<AuthenticateStatus, string>> = {
  [AuthenticateStatus.FAILED_LAST_ATTEMPT_LEFT]:
    'pageLogin.error_AUTHENTICATION_FAILED_LAST_ATTEMPT_LEFT',
  [AuthenticateStatus.FAILED]: 'pageLogin.error_AUTHENTICATION_FAILED',
  [AuthenticateStatus.INCORRECT_REQUEST]:
    'pageLogin.error_AUTHENTICATION_FAILED',
};

const getLoginErrorFromResponse = ({
  data,
  t,
}: GetLoginErrorArgs): LoginErrorResult => {
  const apiErrorCode = data?.apiErrorCode;
  if (apiErrorCode === SERVICE_PROVIDER_ERROR_CODE) {
    return { kind: 'service-provider' };
  }

  const status = data?.status;
  const messageKey = errorCodesToMessages[status as AuthenticateStatus];

  if (messageKey) {
    return { kind: 'field', message: t(messageKey) };
  }

  if (apiErrorCode) {
    return {
      kind: 'notice',
      message: getLoginErrorMessage({
        errorCode: apiErrorCode,
        subscriptionManagementLink:
          data?.errorObject?.subscriptionManagementLink,
        subscriptionPaymentDueDays:
          data?.errorObject?.subscriptionPaymentDueDays,
      }),
    };
  }

  return { kind: 'field', message: t('pageLogin.error_AUTHENTICATION_FAILED') };
};

export default getLoginErrorFromResponse;
